import { gql } from '@apollo/client';

import { PROPERTY_IMAGES_FRAGMENT } from '../fragments/propertyImages';
import { PROPERTY_LOCATION_FRAGMENT } from '../fragments/propertyLocation';
import { PROPERTY_VIEWINGS_FRAGMENT } from '../fragments/propertyViewings';
import { PROPERTY_BID_FRAGMENT } from '../fragments/propertyBid';
import { PROPERTY_LINKS_FRAGMENT } from '../fragments/propertyLinks';
import { PROPERTY_CHECKLISTPOINTS_FRAGMENT } from '../fragments/propertyChecklistpoints';
import { PROPERTY_3DVIEWING_FRAGMENT } from '../fragments/property3dViewing';
import { PROPERTY_PRICE_FRAGMENT } from '../fragments/propertyPrice';
import { PROPERTY_PROJECT_LOGOS_FRAGMENT } from '../fragments/propertyProjectLogos';
import { PROPERTY_NYBYGG_FRAGMENT } from '../fragments/propertyNybygg';
import { PROPERTY_BROKERS_FRAGMENT } from '../fragments/propertyBrokers';
import { PROPERTY_FREETEXT_FRAGMENT } from '../fragments/propertyFreetext';
import { PROPERTY_AREA_FRAGMENT } from '../fragments/propertyArea';
import { PROPERTY_OFFICE_FRAGMENT } from '../fragments/propertyOffice';
import { PROPERTY_DOCUMENTS_FRAGMENT } from '../fragments/propertyDocuments';

export const GET_PROPERTY_QUERY = gql`
  ${PROPERTY_IMAGES_FRAGMENT}
  ${PROPERTY_LOCATION_FRAGMENT}
  ${PROPERTY_VIEWINGS_FRAGMENT}
  ${PROPERTY_BID_FRAGMENT}
  ${PROPERTY_LINKS_FRAGMENT}
  ${PROPERTY_CHECKLISTPOINTS_FRAGMENT}
  ${PROPERTY_3DVIEWING_FRAGMENT}
  ${PROPERTY_PRICE_FRAGMENT}
  ${PROPERTY_NYBYGG_FRAGMENT}
  ${PROPERTY_PROJECT_LOGOS_FRAGMENT}
  ${PROPERTY_BROKERS_FRAGMENT}
  ${PROPERTY_FREETEXT_FRAGMENT}
  ${PROPERTY_AREA_FRAGMENT}
  ${PROPERTY_OFFICE_FRAGMENT}
  ${PROPERTY_DOCUMENTS_FRAGMENT}
  query GetProperty($input: PropertyInput) {
    getProperty(input: $input) {
      id
      id_oppdrag_prosjekt
      preview
      hovedoppdrag
      wmId
      title
      description
      address
      zip
      place
      rooms
      permalink
      bedrooms
      bedroomsTo
      sold
      ...PropertyFreetext
      ...PropertyImages
      ...PropertyLocation
      ...PropertyViewings
      ...PropertyBid
      ...PropertyLinks
      ...PropertyChecklistpoints
      ...Property3DViewing
      ...PropertyPrice
      ...PropertyNybygg
      ...PropertyProjectLogos
      ...PropertyBrokers
      ...PropertyArea
      ...PropertyOffice
      ...PropertyDocuments
    }
  }
`;
